<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-alert message="现货订单汇总所有计费商品的实重与包装体积，取总实重与总抛重较大值；达到快递临界重量后使用关联物流模板，按物流系数重新计算。国际运费由业务员手填。" type="info" show-icon />
      <div class="preset-bar">
        <a-button type="primary" @click="open()">新增模板</a-button>
        <a-button @click="applyJdExpress">套用京东快递报价</a-button>
        <a-button @click="applyJdLogistics">套用京东物流报价</a-button>
      </div>
      <a-table row-key="aid" :columns="cols" :data-source="rows" :pagination="false">
        <template slot="method" slot-scope="v">{{ v === 1 || v === '1' ? '按重量' : '按件数' }}</template>
        <template slot="type" slot-scope="v">{{ ['', '国内快递', '国内物流', '客户自提'][Number(v)] || v }}</template>
        <template slot="meta" slot-scope="t, r">
          <div>抛重系数 {{ r.volumetricDivisor || '-' }}</div>
          <div v-if="Number(r.freight_type) === 1">≥ {{ r.weightThresholdKg }}kg 转 {{ templateName(r.logisticsTemplateId) }}</div>
          <div class="muted">{{ Number(r.manualOnly) === 1 ? '仅手填' : '自动计抛重' }} · 区域 {{ r.ruleCount || 0 }} 条</div>
        </template>
        <template slot="op" slot-scope="t, r">
          <a @click="open(r)">编辑</a>
          <a-divider type="vertical" />
          <a @click="openRules(r)">区域报价</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除？" @confirm="del(r)"><a>删除</a></a-popconfirm>
        </template>
      </a-table>

      <a-modal :visible="visible" width="860px" :title="form.aid ? '编辑运费模板' : '新增运费模板'" :body-style="{ maxHeight: '70vh', overflowY: 'auto' }" @ok="save" @cancel="visible = false">
        <a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
          <a-row>
            <a-col :span="12"><a-form-model-item label="模板名称"><a-input v-model="form.name" /></a-form-model-item></a-col>
            <a-col :span="12"><a-form-model-item label="计费方式"><a-radio-group v-model="form.method"><a-radio :value="1">按重量</a-radio><a-radio :value="2">按件数</a-radio></a-radio-group></a-form-model-item></a-col>
            <a-col :span="12">
              <a-form-model-item label="发货类型">
                <a-select v-model="form.freightType" @change="onTypeChange">
                  <a-select-option :value="1">国内快递</a-select-option>
                  <a-select-option :value="2">国内物流</a-select-option>
                  <a-select-option :value="3">客户自提</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12"><a-form-model-item label="默认模板（同类型）"><a-switch v-model="defaultOn" /></a-form-model-item></a-col>
            <a-col :span="12"><a-form-model-item label="抛重系数"><a-input-number v-model="form.volumetricDivisor" :min="1" :precision="0" style="width:100%" :disabled="manualOn" /><div class="hint">京东快递 8000；京东物流 6000。订单抛重(kg)=总包装体积(cm³)÷系数</div></a-form-model-item></a-col>
            <a-col v-if="form.freightType === 1 && !manualOn" :span="12"><a-form-model-item label="切换物流重量(kg)"><a-input-number v-model="form.weightThresholdKg" :min="1" :precision="0" style="width:100%" /><div class="hint">计费重达到此数值即切换物流，判断时不提前取整</div></a-form-model-item></a-col>
            <a-col v-if="form.freightType === 1 && !manualOn" :span="12"><a-form-model-item label="关联物流模板"><a-select v-model="form.logisticsTemplateId" placeholder="选择达到临界重量后使用的物流模板" style="width:100%"><a-select-option v-for="t in logisticsTemplates" :key="t.aid" :value="Number(t.aid)">{{ t.name }}（系数 {{ t.volumetricDivisor }}）</a-select-option></a-select><div class="hint">物流模板单独维护抛重系数及各地区报价；物流重新计重后不再切回快递</div></a-form-model-item></a-col>
            <a-col :span="12"><a-form-model-item label="仅手填"><a-switch v-model="manualOn" /><div class="hint">国际版、海外物流开启后由业务员在订单中手填</div></a-form-model-item></a-col>
            <a-col :span="24"><a-form-model-item label="说明" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }"><a-textarea v-model="form.freightExplain" :rows="2" /></a-form-model-item></a-col>
          </a-row>
        </a-form-model>
        <a-alert type="info" show-icon message="区域报价请在列表「操作 → 区域报价」中单独新增/编辑；市区可不选，未选时按省级规则计费。" />
      </a-modal>

      <a-modal
        :visible="ruleVisible"
        width="960px"
        :title="(ruleTemplate && ruleTemplate.name ? ruleTemplate.name + ' · ' : '') + '区域报价'"
        :footer="null"
        :body-style="{ maxHeight: '75vh', overflowY: 'auto' }"
        @cancel="closeRules"
      >
        <div class="rule-toolbar">
          <a-button type="primary" size="small" @click="openRuleForm()">新增区域</a-button>
          <a-input-search
            v-model="ruleQuery.keyword"
            allow-clear
            placeholder="搜索省/市/区名称"
            style="width:280px"
            @search="searchRules"
          />
        </div>
        <a-table
          size="small"
          row-key="aid"
          :columns="ruleCols"
          :data-source="rules"
          :pagination="false"
          :loading="ruleLoading"
        >
          <template slot="regionLabel" slot-scope="t, r">{{ r.regionLabel || r.region || '-' }}</template>
          <template slot="rop" slot-scope="t, r">
            <a @click="openRuleForm(r)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确定删除该区域报价？" @confirm="removeRule(r)"><a>删除</a></a-popconfirm>
          </template>
        </a-table>
        <a-pagination
          class="rule-pager"
          show-size-changer
          show-quick-jumper
          :current="ruleQuery.pageNum"
          :page-size="ruleQuery.pageSize"
          :total="ruleTotal"
          :page-size-options="['10','20','50','100']"
          :show-total="n => `共 ${n} 条`"
          @change="changeRulePage"
          @showSizeChange="changeRulePage"
        />
      </a-modal>

      <a-modal
        :visible="ruleFormVisible"
        width="680px"
        :title="ruleForm.aid ? '编辑区域报价' : '新增区域报价'"
        :confirm-loading="ruleSaving"
        :body-style="{ maxHeight: '75vh', overflowY: 'auto' }"
        @ok="saveRule"
        @cancel="ruleFormVisible = false"
      >
        <div class="fee-guide">
          <div class="fee-guide-title">怎么算运费？</div>
          <ol class="fee-guide-list">
            <li><b>不超过首重</b> → 只收<strong>首费</strong></li>
            <li><b>超过首重、不超过第二档上限</b> → 首费 + 超出公斤数 × <strong>第二档单价</strong>（公斤向上取整）</li>
            <li><b>超过第二档上限</b> → 上面费用 + 超出部分按<strong>超上限计费单位</strong>分段 × <strong>超上限单价</strong>（不足一段按一段）</li>
          </ol>
          <div class="fee-guide-example">
            <div class="fee-guide-example-title">举例（首重1kg/首费10元，第二档上限30kg/单价2元，超上限单位1kg/单价3元）</div>
            <div>· 0.8kg → <b>10元</b>（未超首重）</div>
            <div>· 10kg → 10 + 9×2 = <b>28元</b></div>
            <div>· 30kg → 10 + 29×2 = <b>68元</b></div>
            <div>· 35kg → 68 + 5×3 = <b>83元</b>（超上限单位填1才是每公斤3元；填30则每满30kg收3元）</div>
          </div>
          <div v-if="ruleFeePreview" class="fee-guide-preview">
            <div class="fee-guide-example-title">按当前填写试算</div>
            <div v-for="row in ruleFeePreview" :key="row.w">· {{ row.w }}kg → <b>{{ row.fee }}元</b></div>
          </div>
        </div>
        <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item label="配送区域" required>
            <div class="area-row">
              <a-select
                v-model="ruleForm.provinceId"
                show-search
                allow-clear
                placeholder="请选择省"
                style="width:32%"
                option-filter-prop="children"
                @change="onProvinceChange"
              >
                <a-select-option v-for="o in provinceOptions" :key="'p-' + o.value" :value="o.value">{{ o.label }}</a-select-option>
              </a-select>
              <a-select
                v-model="ruleForm.cityId"
                show-search
                allow-clear
                placeholder="市（可选）"
                style="width:32%"
                :disabled="!ruleForm.provinceId"
                option-filter-prop="children"
                @change="onCityChange"
              >
                <a-select-option v-for="o in cityOptions" :key="'c-' + o.value" :value="o.value">{{ o.label }}</a-select-option>
              </a-select>
              <a-select
                v-model="ruleForm.districtId"
                show-search
                allow-clear
                placeholder="区（可选）"
                style="width:32%"
                :disabled="!ruleForm.cityId"
                option-filter-prop="children"
              >
                <a-select-option v-for="o in districtOptions" :key="'d-' + o.value" :value="o.value">{{ o.label }}</a-select-option>
              </a-select>
            </div>
            <div class="hint">省必选；市、区可不选。不选市/区时按该省规则匹配收货地址。</div>
          </a-form-model-item>
          <a-form-model-item label="首重(kg)"><a-input-number v-model="ruleForm.first" :min="0" :precision="2" style="width:100%" /></a-form-model-item>
          <a-form-model-item label="首费"><a-input-number v-model="ruleForm.firstFee" :min="0" :precision="2" style="width:100%" /></a-form-model-item>
          <a-form-model-item label="第二档上限"><a-input-number v-model="ruleForm.additional" :min="0" :precision="2" style="width:100%" /></a-form-model-item>
          <a-form-model-item label="第二档单价"><a-input-number v-model="ruleForm.additionalFee" :min="0" :precision="2" style="width:100%" /></a-form-model-item>
          <a-form-model-item label="超上限计费单位">
            <a-input-number v-model="ruleForm.secAdditional" :min="0" :precision="2" style="width:100%" />
            <div class="hint">填 1 = 超出部分按每公斤计价；填 30 = 每满 30kg 收一次「超上限单价」</div>
          </a-form-model-item>
          <a-form-model-item label="超上限单价"><a-input-number v-model="ruleForm.secAdditionalFee" :min="0" :precision="2" style="width:100%" /></a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  listFreight, getFreight, addFreight, updateFreight, deleteFreight,
  freightAreas, listFreightRules, addFreightRule, updateFreightRule, deleteFreightRule
} from '@/api/dkmall/freight'

const blank = () => ({
  aid: undefined,
  name: '',
  method: 1,
  freightType: 1,
  isDefault: 0,
  status: 1,
  freightExplain: '',
  volumetricDivisor: 8000,
  weightThresholdKg: 30,
  logisticsTemplateId: undefined,
  manualOnly: 0
})

const blankRule = () => ({
  aid: undefined,
  provinceId: undefined,
  cityId: undefined,
  districtId: undefined,
  first: 1,
  firstFee: 0,
  additional: 1,
  additionalFee: 0,
  secAdditional: 1,
  secAdditionalFee: 0
})

export default {
  name: 'DkFreight',
  data() {
    return {
      rows: [],
      visible: false,
      form: blank(),
      cols: [
        { title: '模板名称', dataIndex: 'name' },
        { title: '计费方式', dataIndex: 'method', scopedSlots: { customRender: 'method' } },
        { title: '发货类型', dataIndex: 'freight_type', scopedSlots: { customRender: 'type' } },
        { title: '抛重配置', scopedSlots: { customRender: 'meta' }, width: 220 },
        { title: '说明', dataIndex: 'freightExplain' },
        { title: '操作', scopedSlots: { customRender: 'op' }, width: 200 }
      ],
      ruleVisible: false,
      ruleLoading: false,
      ruleTemplate: null,
      rules: [],
      ruleTotal: 0,
      ruleQuery: { keyword: '', pageNum: 1, pageSize: 20 },
      ruleCols: [
        { title: '区域', scopedSlots: { customRender: 'regionLabel' } },
        { title: '首重(kg)', dataIndex: 'first', width: 90 },
        { title: '首费', dataIndex: 'first_fee', width: 80 },
        { title: '第二档上限', dataIndex: 'additional', width: 100 },
        { title: '第二档单价', dataIndex: 'additional_fee', width: 100 },
        { title: '超上限单位', dataIndex: 'sec_additional', width: 100 },
        { title: '超上限单价', dataIndex: 'sec_additional_fee', width: 100 },
        { title: '操作', scopedSlots: { customRender: 'rop' }, width: 110 }
      ],
      ruleFormVisible: false,
      ruleSaving: false,
      ruleForm: blankRule(),
      provinceOptions: [],
      cityOptions: [],
      districtOptions: []
    }
  },
  computed: {
    logisticsTemplates() {
      return this.rows.filter(t => Number(t.freight_type) === 2 && Number(t.status) === 1 && Number(t.manualOnly) !== 1 && Number(t.aid) !== Number(this.form.aid))
    },
    defaultOn: {
      get() { return this.form.isDefault === 1 },
      set(v) { this.form.isDefault = v ? 1 : 0 }
    },
    manualOn: {
      get() { return this.form.manualOnly === 1 },
      set(v) { this.form.manualOnly = v ? 1 : 0 }
    },
    /** 按当前表单值试算几个常见重量，方便一眼看懂填写结果 */
    ruleFeePreview() {
      const first = Number(this.ruleForm.first) || 0
      const upper = Number(this.ruleForm.additional) || 0
      const weights = Array.from(new Set([
        Math.max(0.1, +(first * 0.5).toFixed(2)),
        Math.max(first + 1, 1),
        upper > first ? upper : first + 5,
        upper > first ? +(upper + 5).toFixed(2) : first + 10
      ].map(w => Number(w)))).filter(w => w > 0).sort((a, b) => a - b).slice(0, 4)
      return weights.map(w => ({
        w: Number.isInteger(w) ? w : +w.toFixed(2),
        fee: this.calcTieredFee(w)
      }))
    }
  },
  created() {
    this.load()
    this.loadProvinces()
  },
  methods: {
    templateName(id) {
      const t = this.rows.find(t => Number(t.aid) === Number(id))
      return t ? t.name : '未关联物流模板'
    },
    load() {
      listFreight().then(r => { this.rows = r.data || [] })
    },
    toSelectOptions(list) {
      return (list || []).map(item => ({
        value: Number(item.value != null ? item.value : item.id),
        label: item.label || item.name || String(item.value != null ? item.value : item.id)
      })).filter(o => o.value > 0)
    },
    loadProvinces() {
      return freightAreas(0).then(r => {
        this.provinceOptions = this.toSelectOptions(r.data)
        if (!this.provinceOptions.length) this.$message.warning('未加载到省份数据，请检查 lb_china_area')
      }).catch(e => {
        this.provinceOptions = []
        this.$message.error((e && e.message) || '省份数据加载失败')
      })
    },
    loadCities(provinceId) {
      if (!provinceId) {
        this.cityOptions = []
        this.districtOptions = []
        return Promise.resolve()
      }
      return freightAreas(provinceId).then(r => {
        this.cityOptions = this.toSelectOptions(r.data)
      }).catch(() => { this.cityOptions = [] })
    },
    loadDistricts(cityId) {
      if (!cityId) {
        this.districtOptions = []
        return Promise.resolve()
      }
      return freightAreas(cityId).then(r => {
        this.districtOptions = this.toSelectOptions(r.data)
      }).catch(() => { this.districtOptions = [] })
    },
    onProvinceChange(val) {
      this.ruleForm.provinceId = val || undefined
      this.ruleForm.cityId = undefined
      this.ruleForm.districtId = undefined
      this.districtOptions = []
      this.loadCities(val)
    },
    onCityChange(val) {
      this.ruleForm.cityId = val || undefined
      this.ruleForm.districtId = undefined
      this.loadDistricts(val)
    },
    applyJdExpress() {
      this.form = {
        ...blank(),
        name: '京东快递',
        method: 1,
        freightType: 1,
        volumetricDivisor: 8000,
        weightThresholdKg: 30,
        freightExplain: '扬州同城：首重1KG 10元，续重每1KG 2元；体积重除数8000。保存后请在「区域报价」中配置各省市区。'
      }
      this.visible = true
    },
    applyJdLogistics() {
      this.form = {
        ...blank(),
        name: '京东物流',
        method: 1,
        freightType: 2,
        volumetricDivisor: 6000,
        weightThresholdKg: 60,
        freightExplain: '江苏省内：20KG以内36元，20-60KG每KG 1.7元，60KG以上每KG 1.6元；体积重除数6000。保存后请在「区域报价」中配置。'
      }
      this.visible = true
    },
    onTypeChange(v) {
      this.form.logisticsTemplateId = undefined
      this.form.manualOnly = v === 3 ? 1 : 0
      this.form.volumetricDivisor = v === 1 ? 8000 : 6000
      this.form.weightThresholdKg = v === 1 ? 30 : 60
    },
    open(r) {
      if (!r) {
        this.form = blank()
        this.visible = true
        return
      }
      getFreight(r.aid).then(x => {
        const d = x.data || {}
        this.form = {
          aid: d.aid,
          name: d.name,
          method: Number(d.method) || 1,
          freightType: Number(d.freight_type) || 1,
          isDefault: Number(d.is_default) || 0,
          status: Number(d.status) || 1,
          freightExplain: d.freightExplain || d.freight_explain || '',
          volumetricDivisor: Number(d.volumetricDivisor) || 8000,
          weightThresholdKg: Number(d.weightThresholdKg) || 30,
          logisticsTemplateId: Number(d.logisticsTemplateId) || undefined,
          manualOnly: Number(d.manualOnly) || 0
        }
        this.visible = true
      })
    },
    save() {
      if (this.form.freightType === 1 && !this.form.manualOnly && !this.form.logisticsTemplateId) {
        return this.$message.warning('请选择关联物流模板')
      }
      if (!this.form.name) return this.$message.warning('请填写模板名称')
      const payload = { ...this.form }
      ;(this.form.aid ? updateFreight : addFreight)(payload).then(() => {
        this.visible = false
        this.$message.success('保存成功')
        this.load()
      })
    },
    del(r) {
      deleteFreight(r.aid).then(() => { this.$message.success('删除成功'); this.load() })
    },
    /** 与后端 FreightCoverage::calcFeeByRule（tiered）一致的三段计费 */
    calcTieredFee(weight) {
      const first = Math.max(0, Number(this.ruleForm.first) || 0)
      const firstFee = Math.max(0, Number(this.ruleForm.firstFee) || 0)
      const secondUpper = Math.max(0, Number(this.ruleForm.additional) || 0)
      const secondRate = Math.max(0, Number(this.ruleForm.additionalFee) || 0)
      const thirdUnit = Math.max(1, Number(this.ruleForm.secAdditional) || 0)
      const thirdRate = Math.max(0, Number(this.ruleForm.secAdditionalFee) || 0)
      const total = Math.max(0, Number(weight) || 0)
      if (total <= first) return firstFee.toFixed(2)
      const extra = total - first
      if (secondUpper <= first) {
        return (firstFee + Math.ceil(extra) * secondRate).toFixed(2)
      }
      let fee = firstFee + Math.ceil(Math.min(extra, secondUpper - first)) * secondRate
      if (total > secondUpper) {
        fee += Math.ceil((total - secondUpper) / thirdUnit) * thirdRate
      }
      return fee.toFixed(2)
    },
    openRules(r) {
      this.ruleTemplate = r
      this.ruleQuery = { keyword: '', pageNum: 1, pageSize: 20 }
      this.ruleVisible = true
      this.loadRules()
    },
    closeRules() {
      this.ruleVisible = false
      this.ruleTemplate = null
      this.rules = []
      this.ruleTotal = 0
      this.load()
    },
    searchRules() {
      this.ruleQuery.pageNum = 1
      this.loadRules()
    },
    changeRulePage(page, pageSize) {
      this.ruleQuery.pageNum = page
      this.ruleQuery.pageSize = pageSize
      this.loadRules()
    },
    loadRules() {
      if (!this.ruleTemplate) return
      this.ruleLoading = true
      listFreightRules(this.ruleTemplate.aid, this.ruleQuery).then(res => {
        const data = res.data || {}
        // 兼容旧接口直接返回数组
        if (Array.isArray(data)) {
          this.rules = data
          this.ruleTotal = data.length
        } else {
          this.rules = data.rows || []
          this.ruleTotal = Number(data.total || 0)
        }
        if (this.ruleTotal > 0 && this.rules.length === 0 && this.ruleQuery.pageNum > 1) {
          this.ruleQuery.pageNum = 1
          this.loadRules()
        }
      }).finally(() => { this.ruleLoading = false })
    },
    openRuleForm(row) {
      const ensureProvinces = this.provinceOptions.length ? Promise.resolve() : this.loadProvinces()
      ensureProvinces.then(() => {
        if (!row) {
          this.ruleForm = blankRule()
          this.cityOptions = []
          this.districtOptions = []
          this.ruleFormVisible = true
          return
        }
        this.ruleForm = {
          aid: row.aid,
          provinceId: row.provinceId ? Number(row.provinceId) : undefined,
          cityId: row.cityId ? Number(row.cityId) : undefined,
          districtId: row.districtId ? Number(row.districtId) : undefined,
          first: Number(row.first) || 0,
          firstFee: Number(row.first_fee) || 0,
          additional: Number(row.additional) || 0,
          additionalFee: Number(row.additional_fee) || 0,
          secAdditional: Number(row.sec_additional) || 0,
          secAdditionalFee: Number(row.sec_additional_fee) || 0
        }
        this.ruleFormVisible = true
        const tasks = []
        if (this.ruleForm.provinceId) tasks.push(this.loadCities(this.ruleForm.provinceId))
        else this.cityOptions = []
        if (this.ruleForm.cityId) tasks.push(this.loadDistricts(this.ruleForm.cityId))
        else this.districtOptions = []
        return Promise.all(tasks)
      })
    },
    saveRule() {
      if (!this.ruleForm.provinceId) return this.$message.warning('请选择省份')
      if (!this.ruleTemplate) return
      this.ruleSaving = true
      const payload = {
        ...this.ruleForm,
        provinceId: this.ruleForm.provinceId || null,
        cityId: this.ruleForm.cityId || null,
        districtId: this.ruleForm.districtId || null
      }
      const req = this.ruleForm.aid
        ? updateFreightRule(this.ruleTemplate.aid, this.ruleForm.aid, payload)
        : addFreightRule(this.ruleTemplate.aid, payload)
      req.then(() => {
        this.$message.success('保存成功')
        this.ruleFormVisible = false
        this.loadRules()
      }).finally(() => { this.ruleSaving = false })
    },
    removeRule(row) {
      deleteFreightRule(this.ruleTemplate.aid, row.aid).then(() => {
        this.$message.success('已删除')
        this.loadRules()
      })
    }
  }
}
</script>

<style scoped>
.muted { color: #8c8c8c; font-size: 12px; }
.hint { color: #f5222d; font-size: 12px; line-height: 1.5; margin-top: 4px; }
.preset-bar { display:flex; gap:10px; margin:16px 0; }
.area-row { display: flex; justify-content: space-between; gap: 8px; width: 100%; }
.rule-toolbar { display:flex; align-items:center; justify-content:space-between; margin-bottom:12px; gap:12px; }
.rule-pager { margin-top: 12px; text-align: right; }
.fee-guide {
  margin: 0 0 16px;
  padding: 12px 14px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 6px;
  color: #262626;
  font-size: 13px;
  line-height: 1.7;
}
.fee-guide-title { font-weight: 600; margin-bottom: 6px; color: #389e0d; }
.fee-guide-list { margin: 0 0 8px; padding-left: 18px; }
.fee-guide-example,
.fee-guide-preview {
  padding: 8px 10px;
  background: #fff;
  border-radius: 4px;
  border: 1px dashed #d9d9d9;
}
.fee-guide-preview { margin-top: 8px; border-color: #95de64; }
.fee-guide-example-title { font-weight: 600; margin-bottom: 4px; }
</style>
